export default __webpack_public_path__ + "950519efc3b5093170b944f240461a5f.svg";